import { Action } from 'redux';
import { CommentsInterface } from './comments.interface';
import * as CommentsActions from './comments.actions';

export interface CommentsState {
    currentComments: CommentsInterface;
}

const initialState: CommentsState = {
    currentComments: {
        videoId: undefined,
        status: undefined,
        topComments: [],
        comments: []
    }
};

export const CommentsReducer =
    function (state: CommentsState = initialState, action: Action): CommentsState {
        switch (action.type) {
            case CommentsActions.CLEARCOMMENTS:
                return {
                    currentComments: {
                        videoId: undefined,
                        status: undefined,
                        topComments: [],
                        comments: []
                    }
                };

            // 拉黑评论者
            case CommentsActions.FILTERCOMMENTS:
                const filterNewState = Object.assign({}, state);

                // filterNewState.currentComments.comments = filterNewState.currentComments.comments.map(comment => {
                //     if (comment.authorId === action['userId']) {
                //         comment.blacklist = true;
                //     }
                //     comment.children = comment.children.map(c => {
                //         if (c.authorId === action['userId']) {
                //             c.blacklist = true;
                //         }
                //         return c;
                //     });
                //     return comment;
                // })

                // 新策略，直接移除被拉黑用户的所有相关评论
                filterNewState.currentComments.comments = filterNewState.currentComments.comments.filter(comment => {
                    if (comment.authorId === action['userId']) {
                      return false;
                    }
                    comment.children = comment.children.filter(c => {
                      if (c.authorId === action['userId']) {
                        return false;
                      }
                      return true;
                    });
                    return true;
                });

                // filterNewState.currentComments.topComments = filterNewState.currentComments.topComments.map(comment => {
                //     if (comment.authorId === action['userId']) {
                //         comment.blacklist = true;
                //     }
                //     comment.children = comment.children.map(c => {
                //         if (c.authorId === action['userId']) {
                //             c.blacklist = true;
                //         }
                //         return c;
                //     });
                //     return comment;
                // })

                // 新策略，直接移除被拉黑用户的所有相关评论
                filterNewState.currentComments.topComments = filterNewState.currentComments.topComments.filter(comment => {
                    if (comment.authorId === action['userId']) {
                        return false;
                    }
                    comment.children = comment.children.filter(c => {
                      if (c.authorId === action['userId']) {
                        return false;
                      }
                      return true;
                    });
                    return true;
                });
                return filterNewState;

            // 取消拉黑评论者
            case CommentsActions.UNFILTERCOMMENTS:
                const unfilterNewState = Object.assign({}, state);
                unfilterNewState.currentComments.comments = unfilterNewState.currentComments.comments.map(comment => {
                    if (comment.authorId === action['userId']) {
                        comment.blacklist = false;
                    }
                    comment.children = comment.children.map(c => {
                        if (c.authorId === action['userId']) {
                            c.blacklist = false;
                        }
                        return c;
                    });
                    return comment;
                })
                unfilterNewState.currentComments.topComments = unfilterNewState.currentComments.topComments.map(comment => {
                    if (comment.authorId === action['userId']) {
                        comment.blacklist = false;
                    }
                    comment.children = comment.children.map(c => {
                        if (c.authorId === action['userId']) {
                            c.blacklist = false;
                        }
                        return c;
                    });
                    return comment;
                })
                //console.log('^^^^^^^^^^^^', unfilterNewState)
                return unfilterNewState;

            case CommentsActions.SETCOMMENTREPORTED:
                const setCommentReportedState = Object.assign({}, state);
                // let finded = setCommentReportedState.currentComments.comments.find(comment => comment.commendId === action['commendId']);
                // if (finded) {
                //     finded.reported = true;
                // }
                // finded = setCommentReportedState.currentComments.topComments.find(comment => comment.commendId === action['commendId']);
                // if (finded) {
                //     finded.reported = true;
                // }

                // 新策略，直接移除被举报的评论ID的评论
                setCommentReportedState.currentComments.comments = setCommentReportedState.currentComments.comments.filter(comment => comment.commendId !== action['commendId']);
                setCommentReportedState.currentComments.topComments = setCommentReportedState.currentComments.topComments.filter(comment => comment.commendId !== action['commendId']);
                return setCommentReportedState;

            case CommentsActions.SETCOMMENTREPORTED:
                const aState = Object.assign({}, state);
                return aState;

            case CommentsActions.INSERT:
                const newComment = (<CommentsActions.InsertAction>action).comments;
                const insertNewState = Object.assign({}, state);
                insertNewState.currentComments.comments.unshift(...newComment.comments);
                return state;

            case CommentsActions.APPEND:
                const moreComments = (<CommentsActions.AppendAction>action).comments;
                const appendNewState = Object.assign({}, state);
                appendNewState.currentComments.topComments = moreComments.topComments;
                appendNewState.currentComments.comments.push(...moreComments.comments);
                return appendNewState;
            case CommentsActions.APPENDTOPARENT:
                const child = (<CommentsActions.AppendAction>action).comments;
                console.log('************************', state.currentComments, child)
                //console.log(child)
                child.comments.forEach(a => {
                    var index = state.currentComments.topComments.findIndex(b => b.commendId == a.replyId + "");
                    if (index > -1) {
                        if (!state.currentComments.topComments[index].children) {
                            state.currentComments.topComments[index].children = [];
                        }
                        state.currentComments.topComments[index].children.unshift(...[a]);
                    }

                    var index = state.currentComments.comments.findIndex(b => Number(b.commendId) == Number(a.replyId));

                    if (index > -1) {
                        if (!state.currentComments.comments[index].children) {
                            state.currentComments.comments[index].children = [];
                        }
                        state.currentComments.comments[index].children.unshift(...[a]);
                    }

                })

                // const appendNewState = Object.assign({}, state);
                // appendNewState.currentComments.topComments = moreComments.topComments;
                // appendNewState.currentComments.comments.push(...moreComments.comments);
                return state;
            default:
                return state;
        }
    };

export const getCommentsState = (state): CommentsState => state.comments;
